<div data-cy="switch-to-live-dialog">
  <h1 mat-dialog-title>
    {{ "switchToLiveTitle" | i18n }}
  </h1>
  <div
    mat-dialog-content
    class="dialog-content">
    <p>{{ "switchToLiveMessage" | i18n }}</p>

    <div class="hint-box">
      <mat-icon svgIcon="information-outline"></mat-icon>
      <span>{{ "generatedDataWillBeDeleted" | i18n }}</span>
    </div>

    <form [formGroup]="optionsForm">
      <h3>{{ "deleteOptions" | i18n }}</h3>
      <mat-checkbox
        formControlName="deleteManualDispos"
        data-cy="delete-manual-dispos-checkbox">
        {{ "deleteManuallyCreatedDispos" | i18n }}
      </mat-checkbox>
      <mat-checkbox
        formControlName="deleteManualPoolers"
        data-cy="delete-manual-poolers-checkbox">
        {{ "deleteManuallyCreatedPoolers" | i18n }}
      </mat-checkbox>
      <mat-checkbox
        formControlName="deleteManualJobs"
        data-cy="delete-manual-jobs-checkbox">
        {{ "deleteManuallyCreatedJobs" | i18n }}
      </mat-checkbox>
      <mat-checkbox
        formControlName="deleteManualEmployments"
        data-cy="delete-manual-employments-checkbox">
        {{ "deleteManuallyCreatedEmployments" | i18n }}
      </mat-checkbox>
    </form>
  </div>
  <div mat-dialog-actions>
    <button
      mat-button
      (click)="cancel()"
      data-cy="dialog-cancel">
      {{ ("cancel" | i18n) || "Cancel" | uppercase }}
    </button>
    <button
      mat-button
      color="primary"
      (click)="confirm()"
      data-cy="dialog-confirm">
      {{ ("switchToLive" | i18n) || "Switch to Live" | uppercase }}
    </button>
  </div>
</div>
